import logo from '../assets/brand.png';
import prodImg from '../assets/productImg.png';
import prodImg2 from '../assets/prodImg2.png';
import prodImg3 from '../assets/prodImg3.png';
import prodImg4 from '../assets/prodImg4.png';
export const dummyList = [
    {
        id: 1,
        logo: logo,
        image: prodImg,
        prodName: 'Shell jacket Dull Surface fabric',
        brandName: 'Jack&Jones',
        color: 'black',
        size: 'medium',
        price: 250,
        discount: 10,
        quantity: 10
    },
    {
        id: 2,
        logo: logo,
        image: prodImg2,
        prodName: 'Philip Camp-Collar ...',
        brandName: 'Jack&Jones',
        color: 'yellow',
        size: '16',
        price: 180,
        quantity: 2
    },
    {
        id: 3,
        logo: logo,
        image: prodImg3,
        prodName: 'Suga Leather Shoes',
        brandName: 'Jack&Jones',
        color: 'grey',
        size: '8',
        price: 300,
        quantity: 6
    },
    {
        id: 4,
        logo: logo,
        image: prodImg4,
        prodName: 'Shell jacket Dull Surface fabric',
        brandName: 'Jack&Jones',
        color: 'blue',
        size: '10',
        price: 500,
        quantity: 1
    }
];

export const invoiceList = {
    pending: [
        {
            id: 1,
            ref: '#TAJ-I35I1I4',
            business: 'Fazsion',
            amount: 500000
        },
        {
            id: 2,
            ref: '#TAJ-I35I4I8',
            business: 'Fazsion',
            amount: 34500
        },
        {
            id: 3,
            ref: '#TAJ-I35L1I6',
            business: 'Fazsion',
            amount: 90500
        },
        {
            id: 4,
            ref: '#TAJ-M36K090',
            business: 'Fazsion',
            amount: 40000
        }
    ],
    fulfiled: [
        {
            id: 1,
            ref: '#TAJ-I35I1I4',
            business: 'Fazsion',
            amount: 500000,
            commision: 25000
        },
        {
            id: 2,
            ref: '#TAJ-I35I4I8',
            business: 'Fazsion',
            amount: 34500,
            commision: 1250
        },
        {
            id: 3,
            ref: '#TAJ-I35L1I6',
            business: 'Fazsion',
            amount: 90500,
            commision: 40250
        },
        {
            id: 4,
            ref: '#TAJ-M36K090',
            business: 'Fazsion',
            amount: 40000,
            commision: 1500
        }
    ]
};
